import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai'
import { atomWithReset, useResetAtom } from 'jotai/utils'

import { getConfig } from './useConfig'
import { LayoutProps } from './Layout/Layout.types'

interface Version {
  version?: string
  isNew?: boolean
}

type NavItemPlacement = 'top' | 'middle' | 'bottom'

interface NavItemSection {
  section: string
}

interface NavItemComponent {
  label: string
  component?: React.ComponentType<any>
  placement?: NavItemPlacement
}

interface DefaultNavITem {
  label: string
  to: string
  external?: boolean
  icon?: React.ReactElement
  counter?: React.ComponentType
  counterUrl?: string
  placement?: NavItemPlacement
  disabled?: boolean
  test?: (params: Record<string, unknown>) => boolean
}

// TODO: сделать нормально чтобы учитывало обязательные поля в определенных типах айтемов
export type NavItem = Partial<NavItemSection> &
  Partial<NavItemComponent> &
  Partial<DefaultNavITem>
export interface RouterParams {
  [key: string]: string
}

export interface LayoutState {
  navItems: NavItem[]
  sidebar?: React.ReactElement
  sidebarBottom?: React.ReactElement
  navbar?: React.ReactElement
  search?: React.ReactElement
  userDropdown?: React.ReactElement
  defaultParams?: RouterParams
}

export type CRMNotifications = {
  case: {
    assignment: { email: boolean; inApp: boolean }
    overdue: { email: boolean; inApp: boolean }
    statusChange: { email: boolean; inApp: boolean }
    daysLeft: {
      enabled: { email: boolean; inApp: boolean }
      limit: string
      repeat: boolean
    }
    newLimits: {
      enabled: { email: boolean; inApp: boolean }
      limit: string
      repeat: boolean
    }
  }
  incidents: {
    new: { email: boolean; inApp: boolean }
    reviewLimit: { email: boolean; inApp: boolean }
    repeat: boolean
    daysLimit: string
  }
  mentions: { email: boolean; inApp: boolean }
}

const defaultLayoutState = {
  navItems: [],
  sidebar: undefined,
  sidebarBottom: undefined,
  navbar: undefined,
  search: undefined,
  userDropdown: undefined,
}

export const layoutState = atom<LayoutState>(defaultLayoutState)

export const appState = atom({})

export const leftSidebarState = atom(true)

export const leftSidebarToggleShowState = atom(true)

export const leftSidebarVersionShowState = atom(true)

export const rightSidebarState = atom(true)

export const rightOverlapSidebarState = atom(false)

export const versionState = atom<Version>({
  version: getConfig().VERSION,
  isNew:
    localStorage.getItem('__last_opened_version') !== getConfig().VERSION,
})

export const searchEntitiesState = atom(false)

export const AppLayout = atomWithReset<LayoutProps>({})

export const useAppLayout = () => useAtomValue(AppLayout)
export const useAppLayoutSetter = () => useSetAtom(AppLayout)
export const useAppLayoutResetter = () => useResetAtom(AppLayout)

export const useLeftSidebarState = () => useAtom(leftSidebarState)

export const useLeftSidebarToggleState = () =>
  useAtom(leftSidebarToggleShowState)

export const useLeftSidebarVersionShowState = () =>
  useAtom(leftSidebarVersionShowState)

export const useRightSidebarState = () => useAtom(rightSidebarState)

export const useRightOverlapSidebarState = () =>
  useAtomValue(rightOverlapSidebarState)

export const useRightOverlapSidebarStateSetter = () =>
  useSetAtom(rightOverlapSidebarState)

export const useVersionState = () => useAtom(versionState)

export const useSearchEntitiesState = () => useAtom(searchEntitiesState)
export const useSearchEntitiesStateSetter = () =>
  useSetAtom(searchEntitiesState)
